import { Link, useLocation } from 'react-router-dom';
import { PageHead } from '@/components/seo/PageHead';
import { ui } from '@/data/nav.en';
import { getLang } from '@/lib/lang';

export function NotFound() {
  const { pathname } = useLocation();
  const lang = getLang(pathname);
  const t = ui[lang];
  return (
    <main className="qb-shell w-full flex-1 py-16">
      <PageHead
        title={t.notFoundTitle}
        description={t.notFoundDesc}
        path={lang === 'en' ? '/en/404/' : '/404/'}
        noindex
      />
      <h1 className="text-3xl font-semibold">{t.notFoundH1}</h1>
      <p className="mt-5">{t.notFoundBody}</p>
      <Link className="qb-button mt-8 inline-block" to={t.home}>{t.notFoundBack}</Link>
    </main>
  );
}
